import { render, staticRenderFns } from "./Despesas.vue?vue&type=template&id=b94517d8&scoped=true&"
import script from "./Despesas.vue?vue&type=script&lang=js&"
export * from "./Despesas.vue?vue&type=script&lang=js&"
import style0 from "./Despesas.vue?vue&type=style&index=0&id=b94517d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94517d8",
  null
  
)

component.options.__file = "Despesas.vue"
export default component.exports